export default {
    baseStyle: (props) => ({
        cartItemBrandText: {
            textTransform: props?.brand === 'garage' ? 'uppercase' : 'capitalize'
        }
    })
}
